import type { IncidentAPI, IncidentsPayloadAPI } from './APITypes';
import moment from 'moment';

import type { Incident, IncidentsPayload } from '@cobliteam/common-types';

export const incidentsTransformer = (incidents: IncidentAPI[]): Incident[] =>
  incidents.map((incident) => ({
    id: incident.id,
    fleetId: incident.fleet,
    type: incident.type,
    deviceId: incident.vehicle.device_id,
    latitude: incident.latitude,
    longitude: incident.longitude,
    date: moment(incident.time).valueOf(),
    licensePlate: incident.vehicle.license_plate || incident.device.cobli_id,
    vehicleBrand: incident.vehicle.brand,
    vehicleModel: incident.vehicle.model,
    read: incident.read,
    driverName: incident.driver?.name,
    info: incident.info,
  }));

export const incidentsPayloadTransformer = (
  incidentsPayload: IncidentsPayload
): IncidentsPayloadAPI => ({
  end_time: incidentsPayload.endTime,
  amount: incidentsPayload.amount,
  start_time: incidentsPayload.startTime,
});
